import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_CMS_URL}/api/v1`,
  timeout: 5000,
  mode: 'no-cors',
  headers: {
    Authorization: null,
  },
});


export default {
  async get(url, config = {}) {
    const { data } = await api.get(url, config);
    return data;
  },
  setToken(token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  },
};
